import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const FinalCTASection = () => {
  const handleBookDemo = () => {
    window.open('https://calendly.com/speakmulti/introduction', '_blank');
  };

  return (
    <section className="section-spacing bg-[var(--bg-primary)]">
      <div className="light-full-container">
        <div className="light-content-container">
          <div className="text-center space-y-12 max-w-4xl mx-auto">
            {/* Header */}
            <div className="space-y-6">
              <h2 className="display-large">
                Start Automating the <span className="text-[var(--brand-primary)]">Impossible</span>
              </h2>
            </div>
            
            {/* Description */}
            <p className="body-large">
              Power your enterprise with explainable, governed, and agentic AI — from database to decision.
            </p>
            
            {/* CTA Button */}
            <div className="flex justify-center">
              <button 
                onClick={handleBookDemo}
                className="btn-primary light-button-animate flex items-center gap-3 text-xl px-8 py-4"
              >
                Book a Demo
                <ArrowRight className="w-6 h-6" />
              </button>
            </div>
            
            {/* Additional Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-8 border-t border-[var(--border-subtle)]">
              <div className="text-center space-y-2">
                <div className="text-2xl font-bold text-[var(--brand-primary)]">15 min</div>
                <div className="body-small">Demo Duration</div>
              </div>
              <div className="text-center space-y-2">
                <div className="text-2xl font-bold text-[var(--brand-primary)]">No Setup</div>
                <div className="body-small">Required</div>
              </div>
              <div className="text-center space-y-2">
                <div className="text-2xl font-bold text-[var(--brand-primary)]">Live</div>
                <div className="body-small">Platform Tour</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;